var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorToastify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9901 11.9926C21.9901 17.5141 17.5141 21.9901 11.9926 21.9901C6.47115 21.9901 1.99512 17.5141 1.99512 11.9926C1.99512 6.47115 6.47115 1.99512 11.9926 1.99512C17.5141 1.99512 21.9901 6.47115 21.9901 11.9926ZM7.78676 9.20083C7.39634 8.8104 7.39634 8.17739 7.78676 7.78697C8.17719 7.39654 8.8102 7.39654 9.20062 7.78697L12.0285 10.6149L14.8558 7.78762C15.2462 7.39719 15.8792 7.39719 16.2697 7.78762C16.6601 8.17804 16.6601 8.81105 16.2697 9.20148L13.4424 12.0287L16.2699 14.8563C16.6604 15.2467 16.6603 15.8797 16.2699 16.2701C15.8795 16.6606 15.2465 16.6606 14.8561 16.2701L12.0285 13.4426L9.20037 16.2708C8.80995 16.6612 8.17694 16.6612 7.78651 16.2708C7.39609 15.8804 7.39609 15.2473 7.78651 14.8569L10.6147 12.0287L7.78676 9.20083Z",
    fill: "#FF5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToastify);
export default __webpack_public_path__ + "static/media/errorToastify.3166b8d2be44fd7eea1635e92451ab31.svg";
export { ForwardRef as ReactComponent };